import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div style={{
      minHeight: '100vh', background: 'var(--navy)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'Inter, sans-serif', padding: 24, textAlign: 'center',
    }}>
      <div style={{ maxWidth: 400 }}>
        <div style={{ fontSize: 72, marginBottom: 8 }}>⚡</div>
        <h1 style={{ fontSize: 72, fontWeight: 900, color: 'var(--teal)', margin: 0, fontFamily: 'JetBrains Mono, monospace' }}>404</h1>
        <h2 style={{ fontSize: 20, fontWeight: 600, color: 'var(--text-1)', marginTop: 12, marginBottom: 8 }}>
          Charger not found
        </h2>
        <p style={{ color: 'var(--text-3)', fontSize: 14, marginBottom: 28 }}>
          This page doesn't exist — but thousands of EV chargers do.
        </p>
        <Link to="/" style={{
          display: 'inline-block', padding: '11px 28px', borderRadius: 10,
          background: 'var(--teal)', color: 'var(--navy)',
          fontWeight: 700, fontSize: 14, textDecoration: 'none',
        }}>
          Back to Map
        </Link>
      </div>
    </div>
  );
}
